import { create } from "zustand";

const getStoredUserData = () => {
  try {
    return JSON.parse(localStorage.getItem("userData")) || {};
  } catch {
    return {};
  }
};

const UserDataSlice = create((set) => ({
  userData: getStoredUserData(),

  createUserDataSlice: (userData) => {
    localStorage.setItem("userData", JSON.stringify(userData));
    set({
      userData: userData,
    });
  },

  clearUserData: () => {
    localStorage.removeItem("userData");
    set({
      userData: {},
    });
  },
}));

export default UserDataSlice;